'use client'

import { cn } from '@/lib/utils'

export interface EditorLoadingPlaceholderProps {
  minHeight: string
  isDisabled: boolean
  className?: string
}

/**
 * Placeholder displayed while the editor is loading
 */
export const EditorLoadingPlaceholder = ({
  minHeight,
  isDisabled,
  className,
}: EditorLoadingPlaceholderProps) => (
  <div
    className={cn(
      'rounded-lg border border-input bg-background',
      isDisabled && 'opacity-50',
      className
    )}
    style={{ minHeight }}
  />
)

EditorLoadingPlaceholder.displayName = 'EditorLoadingPlaceholder'
